export default "__VITE_ASSET__BU7bnPhW__"